import { DateTime } from 'luxon';
import { Model, ModelsApiResponse, TransformedModelsResponse } from './models.api';
import { APIResponse } from '../types/api_response.model';

export interface ModelsMapperTranslations {
  notProvided: string;
}

export interface MappedModel extends Model {
  dateCreatedText: string;
  dateModifiedText: string;
}

// Helper function to extract version from purl
export const extractVersionFromPurl = (model: Model): string | undefined => {
  if (model.purl) {
    // Extract version from purl format: pkg:type/name@version
    const versionMatch = model.purl.match(/@([^?#]+)/);
    if (versionMatch) {
      return versionMatch[1];
    }
  }
  return model.version;
};

/**
 * Processes a single Model to add derived fields like formatted dates and extracted version
 */
export const mapModel = (model: Model): MappedModel => {
  // Extract version from purl if not already set
  let updatedModel = { ...model };

  if (!updatedModel.version && updatedModel.purl) {
    updatedModel.version = extractVersionFromPurl(updatedModel);
  }

  return {
    ...updatedModel,
    dateCreatedText: model.dateCreated
      ? DateTime.fromISO(model.dateCreated).toLocaleString(DateTime.DATETIME_MED)
      : '',
    dateModifiedText: model.dateModified
      ? DateTime.fromISO(model.dateModified).toLocaleString(DateTime.DATETIME_MED)
      : '',
  };
};

/**
 * Processes API response to transform models data
 */
export const mapModelsResponse = (
  response: APIResponse<ModelsApiResponse>,
  assetId: string,
): TransformedModelsResponse => {
  // Extract models for the specific asset from the nested response
  const modelsForAsset = response?.data?.modelsByAsset?.[assetId] || [];

  // Process each model to add derived fields
  const processedModels = modelsForAsset.map(mapModel);

  return {
    data: processedModels,
    success: response?.success || false,
    total: response?.data?.total || 0,
    page: response?.data?.page || 1,
    limit: response?.data?.limit || 10,
  };
};
